/**
 * Minimal shims for Bitmovin event types expected by AngelPlayerContext callbacks.
 *
 * The context barely uses the event payloads — most callbacks read state from
 * the controller directly. These shims provide just enough structure to satisfy
 * the type signatures until Bitmovin types are replaced in Phase 13.
 */
import type {
  AudioChangedEvent,
  PlayerEventBase,
  SubtitleEvent,
  TimeChangedEvent,
  UserInteractionEvent,
} from 'bitmovin-player'
import type { AngelPlayerEvent } from '../AngelPlayerContext/AngelPlayerContext'

export function createUserInteractionShim(issuer: string = 'ui'): UserInteractionEvent {
  return { issuer } as UserInteractionEvent
}

export function createPlayerEventShim(): PlayerEventBase {
  return {} as PlayerEventBase
}

export function createAudioChangedShim(lang: string): AudioChangedEvent {
  return { targetAudio: { lang } } as AudioChangedEvent
}

export function createSubtitleEnabledShim(lang: string): SubtitleEvent {
  return { subtitle: { lang } } as SubtitleEvent
}

export function createSubtitleDisabledShim(): SubtitleEvent {
  return {} as SubtitleEvent
}

export function createTimeChangedShim(): TimeChangedEvent {
  return {} as TimeChangedEvent
}

export function createAngelPlayerEventShim(time: number, hasPlayed: boolean): AngelPlayerEvent {
  return { hasPlayed, time }
}
